<template>
    <div class="success-demo-box">
        <section-title main="合作的成功案例" sub="助力中小机构成长，大型机构进化"></section-title>
        <div class="content">
            <div class="content-item" v-for="(item, index) in objData" :key="index">
                <p class="title"><span>{{item.type_name}}</span></p>
                <div class="school-list">
                    <div class="school-list-item" v-for="(child, index) in item.list" :key="index">
                        <p class="school-name">{{child.school_name}}</p>
                        <p class="school-lan">{{child.school_des}}</p>
                        <p class="info-detail-li">合作时间：{{child.coop_date}}</p>
                        <p class="info-detail-li">合作模式：{{child.coop_type}}</p>
                        <br>
                        <p class="school-president">{{child.president}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { cooperationDemo } from '@/const'
export default {
    data () {
        return {
            objData: cooperationDemo
        }
    }
}
</script>
<style lang="scss" scoped>
.success-demo-box{
    .content{
        .content-item{
            width: 100%;
            text-align: left;
            margin-bottom: 20px;
            .title{
                width:100px;
                height:30px;
                background:rgba(1,130,255,1);
                border-radius:0px 19px 19px 0px;
                font-size:14px;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                color:rgba(255,255,255,1);
                line-height:20px;
                padding: 0px 15px 0px 12px;
                display: flex;
                justify-content: center;
                align-items: center;
                position: -webkit-sticky; /* Safari */
                position: sticky;
                top: 50px;
            }
            .school-list{
                padding: 0px 20px;
                .school-list-item{
                    padding: 20px 15px 17px;
                    background: #F1F3F7;
                    margin-top: 10px;
                    font-size:12px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:#000000;
                    line-height:17px;
                    .school-name{
                        font-size:14px;
                        font-family:PingFangSC-Medium;
                        font-weight:500;
                        color:#272727;
                        line-height:20px;
                    }
                    .school-lan{
                        margin: 9px 0px;
                    }
                }
            }
            &:last-of-type{
                margin-bottom: 0px;
            }
        }
    }
}
</style>